"use strict";

(function (Drupal) {
  Drupal.behaviors.sticky_header = {
    attach: function attach(context, settings) {
      var header = context.querySelector('.header--wrapper');
      if (!header) {
        return;
      }
      var timer;
      var body = document.body;
      var wrapperOffset;
      var scrollOffset = 100;
      var stickyOffset = 200;
      var classes = {
        sticky: 'js-is-sticky',
        scrolled: 'js-is-scrolled',
        hero: 'js-hero-is-scrolled'
      };
      var stickyHeader = function stickyHeader() {
        if (window.scrollY <= 1) {
          wrapperOffset = body.querySelector('.main--wrapper').getBoundingClientRect().top;
        }

        // We set up the sticky header with the new logo after scrolling the distance of scrollOffset.
        // All of our animation is on this "scrolled" class as well.
        if (window.pageYOffset >= scrollOffset) {
          body.classList.add(classes.scrolled);
          // We set the margin top to be the offset of the main wrapper on page load. This prevents jumping.
          if (!body.classList.contains(classes.hero) && wrapperOffset > 1) {
            body.style.marginTop = "".concat(wrapperOffset, "px");
          }
        } else {
          body.classList.remove(classes.scrolled);
          if (!body.classList.contains(classes.hero)) {
            body.style.removeProperty('margin-top');
          }
        }

        // Once we hit stickyOffset, menu slides in. When we slide up we lose sticky class and the menu
        // sneaks back above the header until we hit scrollOffset, where the menu reset happens off viewport.
        // This only happens when there's not a hero on the page.
        if (!body.classList.contains(classes.hero)) {
          if (window.pageYOffset >= stickyOffset) {
            body.classList.add(classes.sticky);
          } else {
            body.classList.remove(classes.sticky);
          }
        }

        // If we are on a page that has a hero, we don't show the sticky nav until
        // we reach the bottom of the header.
        if (body.classList.contains(classes.hero)) {
          var hero = context.querySelector('.hero--component');
          // The offset is the height of the hero.
          var offset = hero.offsetHeight;
          if (window.scrollY >= offset) {
            body.classList.add(classes.sticky);
          } else {
            body.classList.remove(classes.sticky);
          }
        }
      };

      // A way to debounce scroll without killing performance or FE cleanliness.
      // From https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance.
      window.addEventListener('scroll', function () {
        if (timer) {
          this.cancelAnimationFrame(timer);
        }
        timer = this.requestAnimationFrame(stickyHeader);
      }, false);
    }
  };
})(Drupal);